module.exports = __webpack_public_path__ + "img/Doc03-20050108-003.8966e5a6.jpg";